import styled from '@emotion/styled'

export const StyledContainer = styled('div')(({ theme }) => ({
    marginBottom: theme.margins.lg,
}))
